/**
 * Hook centralizado para acceder a la sesión del client_user actual.
 * Hace fetch a /auth/me; si 401, marca como no autenticado.
 *
 * Devuelve `{me, isLoading, isError}` — la UI decide a dónde redirigir.
 */
import { useQuery } from "@tanstack/react-query";
import { api, ApiError } from "./api";

export interface MeResponse {
  user: {
    id: string;
    email: string;
    name: string;
    role: "admin" | "member";
    permissions: string[];
  };
  companies: Array<{
    id: string;
    name: string;
    logoR2Key: string | null;
    accentColor: string | null;
    roleInCompany: "admin" | "member";
  }>;
}

/** Helper para gatear UI por permiso. Si el user no está cargado,
 * conservador: false. */
export function useHasPermission(key: string): boolean {
  const { data } = useMe();
  return data?.user?.permissions?.includes(key) ?? false;
}

export function useMe() {
  return useQuery<MeResponse | null>({
    queryKey: ["auth", "me"],
    queryFn: async () => {
      try {
        return await api.get<MeResponse>("/auth/me");
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    retry: false,
    staleTime: 60_000,
  });
}
